import _trim from 'lodash/trim';

// A Braze test-send recipient may be an email address (resolved to a Braze User
// ID server-side via /users/export/ids) or a raw Braze User ID (external_user_id).
// A value containing '@' is treated as an email and must be well-formed; anything
// else is a User ID and only needs to be non-empty. Shared by BrazeChannelBody
// (per-row invalid feedback) and SendTestDialog (submit gating) so the two never
// disagree on what counts as valid.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isRecipientValid = (value) => {
  const trimmed = _trim(value);

  if (trimmed.length === 0) return false;

  return trimmed.includes('@') ? EMAIL_RE.test(trimmed) : true;
};
